import React, { FunctionComponent, KeyboardEvent, MouseEvent, PropsWithChildren, ReactElement } from "react";

type PropagationStopperProps = PropsWithChildren<{
    readonly children: ReactElement | HTMLElement;
}>;

export const PropagationStopper: FunctionComponent<PropagationStopperProps> = ({ children }) => {
    const stopPropagation = (e: MouseEvent<HTMLDivElement>) => e.stopPropagation();
    const stopKeyPropagation = (e: KeyboardEvent<HTMLDivElement>) => e.stopPropagation();

    /*
        Tato komponenta se stopováním propagace je bohužel nutná.
        Z neznámého důvodu se eventy přenášejí do picassa a tohle byl jedinný 100% způsob, jak je stopnout.
        Myslím, že problém je v tom, že si react myslí, že ActivityEditDialog je potomek Activity komponenty,
        ale ve skutečnosti tomu tak není. Proto se editační dialog chová korektně při spuštění odjinud.
        Pravděpodobně se jedná o "bug", který je popsán zde: https://github.com/facebook/react/issues/11387
    */

    return (
        <div
            onMouseDown={stopPropagation}
            onMouseMove={stopPropagation}
            onMouseOver={stopPropagation}
            onClick={stopPropagation}
            onWheel={stopPropagation}
            onDoubleClick={stopPropagation}
            onKeyDown={stopKeyPropagation}
            onKeyUp={stopKeyPropagation}>
            {children}
        </div>
    );
};
